import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Page from '../../services/api/page';
import { Row, Col, Button } from 'antd';

import './styles.css';

class SubMenu extends Component {
  state = {
    sub_menu_active: '',
    sub_menu_data: {},
  };

  handleClickMenu = (name) => {
    this.setState({
      sub_menu_active: name,
    });
  };

  updateLink = () => {};

  render() {
    const item_submenu = this.props.object_sub_menu.sub_menu_item
      ? this.props.object_sub_menu.sub_menu_item.map((item, index) => {
          return (
            <div key={index}>
              {item.nombre === 'Probar ahora' ? (
                <a href={`${Page.constants.url_cuenta}/${item.url}`}>
                  <Button type="default" className="btn--probar--ahora">
                    {item.nombre}
                  </Button>
                </a>
              ) : (
                <div>
                  <Link to={`${this.props.object_sub_menu.url}${item.url ? item.url : '#'}`}>
                    <span
                      className={`submenu__nav--texto ${this.props.object_sub_menu.sub_menu_active === 'empresa-online' ? 'submenu__active' : ''}`}
                      onClick={() => {
                        this.handleClickMenu('especificaciones');
                      }}
                    >
                      {item.nombre ? item.nombre : ''}
                    </span>
                  </Link>
                </div>
              )}
            </div>
          );
        })
      : '';

    return (
      <div className="submenu--full" id="submenu--full">
        <div className="contenedor sub--menu responsive">
          <Row>
            <Col className="submenu__contenedor">
              <div>
                <h4 className="nombre__titulo">{this.props.object_sub_menu.submenu_nombre_titulo}</h4>
              </div>
              <div className="submenu__nav">{item_submenu}</div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default SubMenu;
